import { useContext } from "react";
import Card from "./Card";
import { useLanguage } from "../../context/LanguageContext";
import { AuthContext } from "../../context/context";
import BarChartActivity from "./BarChartActivity";
import BtnSecondaryS from "../Buttons/BtnSecondaryS";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import isoWeek from "dayjs/plugin/isoWeek";
import { TbEye } from "react-icons/tb";
dayjs.extend(isoWeek);

const CardProgressJournal = ({ cardClassName, useMaxHeight = true }) => {
  const { copy } = useLanguage();
  const { userData } = useContext(AuthContext);
  const navigate = useNavigate();

  return (
    <Card
      title={copy.card_progress.headline_journal}
      description={copy.card_progress.description_journal}
      useMaxHeight={useMaxHeight}
      cardClassName={cardClassName || "h-full"}
    >
      <div className="flex flex-col gap-5 h-full items-center justify-between !mt-2">
        {/* Bar chart */}
        {(() => {
          const today = dayjs();
          const startOfWeek = today.startOf("isoWeek");
          const days = Array.from({ length: 7 }, (_, i) =>
            startOfWeek.add(i, "day")
          );
          const noteCounts = days.map((day) => {
            const dayStr = day.format("YYYY-MM-DD");
            const notesForDay = userData.notes.filter((note) => {
              const noteStr = dayjs(note.note_date).format("YYYY-MM-DD");
              return noteStr === dayStr;
            });
            return notesForDay.length;
          });
          const totalNotesThisWeek = noteCounts.reduce((a, b) => a + b, 0);
          const totalNotesThisYear = userData.notes.filter((note) =>
            dayjs(note.note_date).isSame(today, "year")
          ).length;
          // --- Year-long streak calculation ---
          const yearStart = today.startOf("year");
          const noteDateSet = new Set(
            userData.notes.map((note) =>
              dayjs(note.note_date).format("YYYY-MM-DD")
            )
          );
          let streakYear = 0;
          let d = today;
          while (d.isAfter(yearStart) || d.isSame(yearStart, "day")) {
            const dateStr = d.format("YYYY-MM-DD");
            if (noteDateSet.has(dateStr)) {
              streakYear++;
            } else {
              if (d.isSame(today, "day")) {
                // Allow user to keep streak until end of today
              } else {
                break;
              }
            }
            d = d.subtract(1, "day");
          }
          return (
            <>
              <div className="">
                <BarChartActivity data={noteCounts} days={days} />
              </div>
              <div className="w-full grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 text-base font-medium gap-2">
                <div className="flex flex-col items-center card-base-border rounded-md p-2 justify-center">
                  <span className="text-2xl">{totalNotesThisWeek}</span>
                  <span className="md:text-xs text-sm mt-1">
                    notes this week
                  </span>
                </div>
                <div className="flex flex-col items-center card-base-border rounded-md p-2 justify-center">
                  <span className="text-2xl">{streakYear}</span>
                  <span className="md:text-xs text-sm mt-1">streak</span>
                </div>
                <div className="flex flex-col items-center card-base-border rounded-md p-2 justify-center">
                  <span className="text-2xl">{totalNotesThisYear}</span>
                  <span className="md:text-xs text-sm mt-1">
                    notes this year
                  </span>
                </div>
                <div 
                  className="flex flex-col items-center card-base-border rounded-md p-2 justify-center cursor-pointer bg-accent-light transition-colors hover:shadow-lg"
                  onClick={() => navigate("/calendar")}
                >
                  <TbEye className="text-xl mb-1" />
                  <span className="text-sm text-center">View all in calendar</span>
                </div>
              </div>
            </>
          );
        })()}
      </div>
    </Card>
  );
};

export default CardProgressJournal;
